import { Icon, Link, Typography } from "@material-ui/core";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import CardHeader from '@material-ui/core/CardHeader';
import { withStyles } from "@material-ui/core/styles";
import React from "react";
import { useTranslation } from 'react-i18next';
import { getHostPrefix } from "../../../helpers";
import useFilePath from "../../../hooks/useFilePath";
import styles from "./securityInfoCard.styles";

const SecurityInfoCard = (props) => {

  const { classes } = props;
  const { t } = useTranslation();

    // build file path url
    const hostPrefix = getHostPrefix();
    const clientFilePath = `${process.env.PUBLIC_URL}/static/clients/${hostPrefix}/Seguridad_Digital.pdf`;
    const defaultClientFilePath = `${process.env.PUBLIC_URL}/static/clients/default/Seguridad_Digital.pdf`;
    const clientFraudFilePath = `${process.env.PUBLIC_URL}/static/clients/${hostPrefix}/Prevencion_Fraude_Digital.pdf`;
    const defaultFraudFilePath = `${process.env.PUBLIC_URL}/static/clients/default/Prevencion_Fraude_Digital.pdf`;
    // check if file exists  
    const filePath = useFilePath(clientFilePath, defaultClientFilePath);
    const fraudFilePath = useFilePath(clientFraudFilePath, defaultFraudFilePath);

  return (
    filePath && (
        <Card className={classes.card}>
        <CardHeader
            className={classes.cardHeader}
            avatar={
            <Icon color="disabled" style={{ fontSize: 25 }}>
                warning
            </Icon>
            }
            title={t('dashboard.securityInfoCardHeader')}
            titleTypographyProps={{ variant: "h6", color: "textSecondary" }}
        />
        <CardContent className={classes.cardContent}>
            <div className={classes.cardData}>
                <>
                    <Typography variant="body2" className={classes.linkItem}>
                        <Link href={filePath} target="_blank" underline="hover">
                            &#11146; { t('dashboard.securityInfoCardLinkLabel')}
                        </Link>
                    </Typography>
                    <Typography variant="body2" className={classes.linkItem}>
                        <Link href={fraudFilePath} target="_blank" underline="hover">
                            &#11146; { t('dashboard.fraudPreventionLinkLabel')}
                        </Link>
                    </Typography>
                </>
            </div>
        </CardContent>
        </Card>
    ));
}

export default withStyles(styles)(SecurityInfoCard);
